<template>
  <div class="generator-cont margin" :class="size == 'small' ? 'small' : 'big'">
    <label v-if="type == 'input' && !mask"
           class="input-cont input-cont_small ">
      <p class="label">{{translateLabel(label)}}</p>
      <input type="text"
             :disabled="disabled"
             @keypress="checkValidations"
             :value="value"
             @change="changeInput($event)"
             :placeholder="translateLabel(placeholder)">
    </label>

    <label v-if="type == 'input' && mask"
           class="input-cont input-cont_small ">
      <p class="label">{{translateLabel(label)}}</p>
      <input type="text"
             :disabled="disabled"
             @keypress="checkValidations"
             :value="value"
             v-mask="mask"
             @change="changeInput($event)"
             @input="$emit('input', $event.target.value)"
             :placeholder="translateLabel(placeholder)">
    </label>

    <label class="textarea-wrap margin" v-if="type == 'textarea'">
      <p class="label">{{translateLabel(label)}}</p>
      <textarea :disabled="disabled"
                :value="value"
                @change="changeInput($event)"
                :placeholder="translateLabel(placeholder)"></textarea>
    </label>

    <div class="select-cont margin" :class="{'select-cont_multiple': multiple}" v-if="type == 'select'">
      <p class="label">{{translateLabel(label)}}</p>
      <v-select :clearable="false"
                :multiple="multiple"
                :searchable="multiple ? true : false"
                :filterable="multiple ? true : false"
                :close-on-select="true"
                :select-on-tab="!disabled"
                :value="value"
                :disabled="disabled"
                @input="changeSelect"
                :options="options"></v-select>
    </div>

    <label class="check-cont check-cont_small" v-if="type == 'check'">
      <input type="checkbox"
             :disabled="disabled"
             @change="changeCheckbox"
             :checked="value">
      <p class="check-label">{{translateLabel(label)}}</p>
    </label>

    <div class="list-cont" v-if="type == 'list'">
      <p class="label">{{translateLabel(label)}}</p>
      <ul class="form-list" >
        <li v-for="(item,i) in options" :key="'list' + label + i">
          <p>{{item}}</p>
          <button type="button"
                  v-if="!disabled"
                  @click="delItem(i)"
                  class="del-item"></button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import errors from '../errors'
  import {validate} from "../../../mixins/utils/validate";

  export default {
    name: 'userGenerator',
    props: {
      index: {
        type: Number
      },
      type: {
        type: String
      },
      value: {
        type: String || Boolean
      },
      required: {
        type: Boolean
      },
      multiple: {
        type: Boolean,
        required: false
      },
      placeholder: {
        type: String,
        required: false
      },
      label: {
        type: String,
        required: false
      },
      options: {
        type: Array,
        required: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        required: false
      },
      validations: {
        type: Array,
        required: false
      },
      mask: {
        type: String,
        required: false
      }
    },
    mixins: [validate],
    components: {
      errors
    },
    methods: {
      translateLabel(val) {
        let value = val;
        if (val == 'Имя пользователя') {
          value = this.$t('forms.nameLb')
        } else if (val == 'Описание') {
          value = this.$t('forms.descLb');
        } else if (val == 'Страна') {
          value = this.$t('forms.countryLb');
        } else if (val == 'Индекс') {
          value = this.$t('forms.postalLb');
        } else if (val == 'Адрес') {
          value = this.$t('forms.addressLb');
        } else if (val == 'Телефон') {
          value = this.$t('forms.telLb');
        } else if (val == 'Эл.адрес') {
          value = this.$t('forms.emailLb');
        } else if (val == 'Город') {
          value = this.$t('forms.countryLb')
        } else if (val == 'Список пользователей') {
          value = this.$t('forms.userList')
        } else if (val == 'Всегда в полноэкранном режиме') {
          value = this.$t('forms.fullscreen')
        }


        return value
      },
      changeInput(e) {
        this.$emit('change', e.target.value)
      },
      changeSelect(val) {
        this.$emit('change', val)
      },
      changeCheckbox(e) {
        this.$emit('change', e.target.checked)
      },
      checkValidations(e) {
        if (this.validations) {
          if (this.validations.indexOf('string') >= 0) {
            this.delNumbers(e)
          }
          ;

          if (this.validations.indexOf('number') >= 0) {
            this.delString(e)
          }
          ;
        }
      },
      delItem(i) {
        this.$emit('del', i)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .generator-cont {
    width: 100%;
  }

  .margin {
    margin-bottom: 10px;
  }

  .big {
    width: 100%;
  }

  .small {
    width: calc(50% - 10px);

  }

  .form-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    li {
      background: #F5F8FA;
      padding: 10px 5px;
      padding-right: 5px;
      font-family: $mr;
      font-size: 14px;
      letter-spacing: 0.25px;
      width: calc(50% - 5px);
      border-radius: 3px;
      display: flex;
      margin-bottom: 10px;
      border: 1px solid #D7E3EA;
      display: flex;
      align-items: center;
      min-height: 42px;

      p {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .del-item {
      width: 20px;
      height: 20px;
      margin-left: auto;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      &::before, &::after {
        content: '';
        position: absolute;
        width: 15px;
        height: 2px;
        background: #D7E3EA;
        transition: $anim;
      }

      &::before {
        transform: rotate(45deg);
      }

      &::after {
        transform: rotate(-45deg);
      }

      &:hover {
        &::before, &::after {
          background: $darkBlue;
        }
      }
    }
  }

</style>
